// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintExportStep-cls1__yo","cls2":"PreprintExportStep-cls2_N8E PreprintExportStep-cls1__yo"};